import React, { useState } from "react";
import { Input, Button, List, Avatar,Drawer,Space } from "antd";

const ChatBox = () => {
	const [userInput, setUserInput] = useState("");
	const [chatHistory, setChatHistory] = useState([]);

	const sendMessage = async () => {
		const apiUrl = "https://chatbotapi-5v0y.onrender.com";

		const userId = "1";

		
		const requestBody = {
			user_id: userId,
			user_input: userInput,
		};

		try {
			const response = await fetch(apiUrl, {
				method: "POST",
				headers: {
					"Content-Type": "application/json",
				},
				body: JSON.stringify(requestBody),
			});

			if (!response.ok) {
				throw new Error("Failed to send message");
			}

			const responseData = await response.json();

			setChatHistory([
				...chatHistory,
				{ user: "user", message: userInput },
				{ user: "bot", message: responseData.response },
			]);

			setUserInput("");
		} catch (error) {
			console.error("Error sending message",error);
		}
	};

    const [open, setOpen] = useState(false);
		const placement = "right";
		const showDrawer = () => {
			setOpen(true);
		};
		
		const onClose = () => {
			setOpen(false);
		};

	return (
		<>
			<Button type="primary" onClick={showDrawer}>
				Open
			</Button>
			<Drawer
				title="WALL-E CHAT BOT"
				placement={placement}
				width={500}
				onClose={onClose}
				open={open}
				>
				<div>
					<List
						itemLayout="horizontal"
						dataSource={chatHistory}
						renderItem={(item) => (
							<List.Item>
								<List.Item.Meta
									avatar={
										<Avatar
											src={`https://avatars.dicebear.com/api/human/${item.user}.svg`}
										/>
									}
									title={item.user}
									description={item.message}
								/>
							</List.Item>
						)}
					/>
					<Input
						placeholder="Type your message here"
						value={userInput}
						onChange={(e) => setUserInput(e.target.value)}
						style={{ width: "70%", marginRight: "8px" }}
					/>
					<Button type="primary" onClick={sendMessage}>
						Send
					</Button>
				</div>
			</Drawer>
		</>
	);
};

export default ChatBox;
